export const placeholder_platforms = Object.freeze([
  { id: 4, name: 'Proba Analytics', app_code: 'PROBA_A', environment: 'UAT', status: 'Connected' },
  { id: 7, name: 'EngageNet', app_code: 'ENGAGENET', environment: 'Production', status: 'Connected' },
  { id: 9, name: 'ComplyOn', app_code: 'COMPLYON', environment: 'Staging', status: 'Pending' },
]);

export const placeholder_configurations = Object.freeze([
  {
    id: 101,
    platform: 4,
    platform_id: 4,
    platform_name: 'Proba Analytics',
    app_code: 'PROBA_A',
    organization_id: null,
    environment: 'UAT',
    base_url: 'https://uat.proba.example.com',
    launch_url: 'https://uat.proba.example.com/sso/assert',
    health_endpoint: 'https://uat.proba.example.com/health',
    status: 'Ready',
    github_sync_status: 'Not Synced',
    checklist: {
      INTERNAL_API_KEY: { masked_value: 'sk_live_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢A12X', one_time_value: '' },
      SSO_SHARED_SECRET: { masked_value: 'sec_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢92QK', one_time_value: '' },
      MAX_ALLOWED_SKEW: { masked_value: 'â€¢â€¢â€¢120', one_time_value: '' },
      SYSTEM: { masked_value: 'PROBA_A', one_time_value: 'PROBA_A' },
    },
  },
  {
    id: 102,
    platform: 7,
    platform_id: 7,
    platform_name: 'EngageNet',
    app_code: 'ENGAGE_CORE',
    organization_id: null,
    environment: 'Production',
    base_url: 'https://launch.engagenet.example.com',
    launch_url: 'https://launch.engagenet.example.com/sso/assert',
    health_endpoint: 'https://launch.engagenet.example.com/health',
    status: 'Needs Review',
    github_sync_status: 'Not Synced',
    checklist: {
      INTERNAL_API_KEY: { masked_value: 'sk_prod_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢D41M', one_time_value: '' },
      SSO_SHARED_SECRET: { masked_value: 'sec_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢18PL', one_time_value: '' },
      MAX_ALLOWED_SKEW: { masked_value: 'â€¢â€¢â€¢180', one_time_value: '' },
      SYSTEM: { masked_value: 'ENGAGE_CORE', one_time_value: 'ENGAGE_CORE' },
    },
  },
  {
    id: 103,
    platform: 9,
    platform_id: 9,
    platform_name: 'ComplyOn',
    app_code: 'COMPLY_STG',
    organization_id: null,
    environment: 'Staging',
    base_url: 'https://staging.complyon.example.com',
    launch_url: 'https://staging.complyon.example.com/sso/assert',
    health_endpoint: 'https://staging.complyon.example.com/health',
    status: 'Draft',
    github_sync_status: 'Not Synced',
    checklist: {
      INTERNAL_API_KEY: { masked_value: 'sk_stage_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢L09T', one_time_value: '' },
      SSO_SHARED_SECRET: { masked_value: 'sec_â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢41WX', one_time_value: '' },
      MAX_ALLOWED_SKEW: { masked_value: 'â€¢â€¢â€¢300', one_time_value: '' },
      SYSTEM: { masked_value: 'COMPLY_STG', one_time_value: 'COMPLY_STG' },
    },
  },
]);

export const placeholder_access_assignments = Object.freeze([
  { id: 1, platform_name: 'Proba Analytics', principal_name: 'Organization Admin', access_level: 'Launch + Configure', environment: 'UAT', status: 'Assigned' },
  { id: 2, platform_name: 'EngageNet', principal_name: 'Implementation Team', access_level: 'Readiness Only', environment: 'Production', status: 'Assigned' },
  { id: 3, platform_name: 'ComplyOn', principal_name: 'Support Team', access_level: 'Launch Test', environment: 'Staging', status: 'Pending' },
]);

export const placeholder_launch_tests = Object.freeze([
  { id: 1, platform_name: 'Proba Analytics', app_code: 'PROBA_A', environment: 'UAT', last_tested_at: '2026-05-05 09:15', result: 'Passed' },
  { id: 2, platform_name: 'EngageNet', app_code: 'ENGAGE_CORE', environment: 'Production', last_tested_at: '2026-05-05 13:40', result: 'Awaiting Retry' },
]);
